module.exports = __webpack_public_path__ + "static/neuro-room-220e0f289ba173a37c22d474f991158f.jpg";